import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getEquipmentPledges(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT_PLEDGES,
		ModulesConfigMap[ModulesMap.EQUIPMENT_PLEDGES].GET_EQUIPMENT_PLEDGES,
		options
	)
}

function _getEquipmentPledge(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT_PLEDGES,
		ModulesConfigMap[ModulesMap.EQUIPMENT_PLEDGES].GET_EQUIPMENT_PLEDGE,
		options
	)
}

function _createEquipmentPledge(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT_PLEDGES,
		ModulesConfigMap[ModulesMap.EQUIPMENT_PLEDGES].CREATE_EQUIPMENT_PLEDGE,
		options
	)
}

function _patchEquipmentPledge(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT_PLEDGES,
		ModulesConfigMap[ModulesMap.EQUIPMENT_PLEDGES].PATCH_EQUIPMENT_PLEDGE,
		options
	)
}

function _putEquipmentPledge(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT_PLEDGES,
		ModulesConfigMap[ModulesMap.EQUIPMENT_PLEDGES].PUT_EQUIPMENT_PLEDGE,
		options
	)
}

function _deleteEquipmentPledge(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT_PLEDGES,
		ModulesConfigMap[ModulesMap.EQUIPMENT_PLEDGES].DELETE_EQUIPMENT_PLEDGE,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.EQUIPMENT_PLEDGES].GET_EQUIPMENT_PLEDGES]: _getEquipmentPledges,

	[ModulesConfigMap[ModulesMap.EQUIPMENT_PLEDGES].GET_EQUIPMENT_PLEDGE]: _getEquipmentPledge,

	[ModulesConfigMap[ModulesMap.EQUIPMENT_PLEDGES].CREATE_EQUIPMENT_PLEDGE]: _createEquipmentPledge,

	[ModulesConfigMap[ModulesMap.EQUIPMENT_PLEDGES].PATCH_EQUIPMENT_PLEDGE]: _patchEquipmentPledge,

	[ModulesConfigMap[ModulesMap.EQUIPMENT_PLEDGES].PUT_EQUIPMENT_PLEDGE]: _putEquipmentPledge,

	[ModulesConfigMap[ModulesMap.EQUIPMENT_PLEDGES].DELETE_EQUIPMENT_PLEDGE]: _deleteEquipmentPledge,
}
